import { useContext } from 'react';
import { MerchantContext } from '../contexts/MerchantContext';

// ----------------------------------------------------------------------

const useMerchant = () => {
  const context = useContext(MerchantContext);

  if (!context) throw new Error('Merchant context must be use inside MerchantProvider');

  return context;
};

export default useMerchant;
